/** @format */

import React from 'react';
import Grid from '@material-ui/core/Grid';
import PercentageCircle from 'src/ui/library/PercentageCircle';
import QuestionnaireTopHeader from './QuestionnaireTopHeader';
import { ActionsBarContainer } from 'src/ui/features/Questionnaire/containers';
import { QUESTIONNAIRE_PAGE_URL, QUESTIONNAIRE_SECTION_URL } from 'src/constants/constants.js';
import urlParamsMapper from 'src/helpers/urlParamsMapper.js';
//import ServiceSpinnerPres from "src/ui/features/ServiceInit/presentational/ServiceSpinnerPres";
import ServiceSpinner from 'src/ui/library/ServiceSpinner';
import intl from 'react-intl-universal';

const goldColor = '#f5a623';
const greenColor = '#2eb757';

const parsePercentString = value => parseInt(value, 10);

const getDescriptionText = (descriptionsArr, value) => {
  let descriptionText = descriptionsArr.filter(d => d.sectionName === value);
  descriptionText = descriptionText[0] ? descriptionText[0].description : '';
  return descriptionText;
};

export const QuestionnaireCompletePres = ({
  // gettingIntroData,
  introData,
  push,
  // goBack,
  match,
  isMobile,
  history,
}) => {
  if (!introData) {
    return <ServiceSpinner />;
  }
  const data = introData;
  const overallProgress = parsePercentString(data.overallProgress);
  let { sectionName } = match.params;
  sectionName = (data.sectionNameOldNew && JSON.parse(data.sectionNameOldNew)[sectionName]) || sectionName;
  match.params.sectionName = sectionName;
  const completeData = data.menus.filter(m => m.menuName === sectionName)[0] || {};
  const completeProgress = parsePercentString(completeData.sectionProgress);
  const completeURL = urlParamsMapper(QUESTIONNAIRE_SECTION_URL, match.params);
  const isComplete100 = completeProgress === 100;
  const nextDataIndex = data.menus.findIndex(m => m.menuName === sectionName) + 1;
  const nextData = nextDataIndex >= data.menus.length ? null : data.menus[nextDataIndex];
  let nextProgress;
  let nextURL;
  if (nextData) {
    nextProgress = parsePercentString(nextData.sectionProgress);
    nextURL = urlParamsMapper(QUESTIONNAIRE_SECTION_URL, {
      ...match.params,
      sectionName: nextData.menuName,
    });
  }
  return (
    <div>
      <QuestionnaireTopHeader
        title={completeData.menuName}
        onBack={() => push(urlParamsMapper(QUESTIONNAIRE_PAGE_URL, match.params))}
        data={data}
        overallProgress={overallProgress}
      />
      <article className="questionnaire-complete-container">
        <header history={history} className="hide-mobile">
          {data.questionnaireName}
          <div className="questionnaire-status">
            <span>{intl.get('questionnaire.overAllProgress')}</span>
            <span>
              <PercentageCircle
                color={overallProgress === 100 ? greenColor : goldColor}
                percent={overallProgress}
                radius={28}
                textStyle="circle-font-size"
                borderWidth={4}
              />
            </span>
          </div>
        </header>
        <div className="add-side-margins">
          <div className="questionnaire-items">
            <div className="questionnaire-item">
              <div className="questionnaire-complete-item-header">
                <span>
                  {isComplete100 ? (
                    <span className="space-after">{intl.get('questionnaire.complete')}</span>
                  ) : (
                    <span className="space-after">{intl.get('questionnaire.incomplete')}</span>
                  )}
                </span>
              </div>
              <div className="questionnaire-complete-item-content">
                <Grid container spacing={16}>
                  <Grid item xs={4}>
                    <PercentageCircle
                      color={isComplete100 ? greenColor : goldColor}
                      percent={completeProgress}
                      radius={isMobile ? 40 : 45}
                      textStyle="circle-font-size"
                      borderWidth={6}
                    />
                  </Grid>
                  <Grid item xs={8}>
                    <p>{completeData.menuName}</p>
                    <p>{getDescriptionText(data.descriptions, completeData.menuName)}</p>
                  </Grid>
                </Grid>
              </div>
              <div className="questionnaire-item-link-bar">
                <a
                  href={completeURL}
                  onClick={e => {
                    e.preventDefault();
                    push(completeURL);
                  }}>
                  {isComplete100 ? (
                    <span>{intl.get('questionnaire.editCompletedSection')}</span>
                  ) : (
                    <span>{intl.get('questionnaire.editSection')}</span>
                  )}
                </a>
              </div>
            </div>
            {nextData && (
              <div className="questionnaire-item">
                <div className="questionnaire-complete-item-header">
                  <span>{intl.get('questionnaire.nextUp')}</span>
                </div>
                <div className="questionnaire-complete-item-content">
                  <Grid container spacing={16}>
                    <Grid item xs={4}>
                      <PercentageCircle
                        color={nextProgress === 100 ? greenColor : goldColor}
                        percent={nextProgress}
                        radius={isMobile ? 40 : 45}
                        textStyle="circle-font-size"
                        borderWidth={6}
                      />
                    </Grid>
                    <Grid item xs={8}>
                      <p>{nextData.menuName}</p>
                      <p>{getDescriptionText(data.descriptions, nextData.menuName)}</p>
                    </Grid>
                  </Grid>
                </div>
                <div className="questionnaire-item-link-bar">
                  <a
                    href={nextURL}
                    onClick={e => {
                      e.preventDefault();
                      push(nextURL);
                    }}>
                    {nextProgress === 0 ? intl.get('questionnaire.startNext') : intl.get('questionnaire.continue')}
                    <span className="space-before">{intl.get('questionnaire.section')}</span>
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </article>
      <ActionsBarContainer
        progressTitle={completeData.menuName}
        percentProgress={completeProgress}
        isPageVariant={true}
        routeParams={match.params}
        noSave={true} // temp
      />
    </div>
  );
};
export default QuestionnaireCompletePres;



// WEBPACK FOOTER //
// ./src/ui/features/Questionnaire/presentational/QuestionnaireCompletePres.js